import PDFDict from 'PDFLib/core/objects/PDFDict';
import PDFRef from 'PDFLib/core/objects/PDFRef';
import PDFAcroTerminal from 'PDFLib/core/acroform/PDFAcroTerminal';

class PDFAcroSignature extends PDFAcroTerminal {
  static fromDict = (dict: PDFDict, ref: PDFRef) =>
    new PDFAcroSignature(dict, ref);
}

export default PDFAcroSignature;
